var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.68629 0 0 2.68629 0 6V18C0 21.3137 2.68629 24 6 24H18C21.3137 24 24 21.3137 24 18V6C24 2.68629 21.3137 0 18 0Z",
    fill: "#50ABF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00068 16.2175C7.08709 16.9243 8.37581 17.3333 9.75727 17.3333C13.6383 17.3333 16.7844 14.1056 16.7844 10.1248C16.7844 10.0254 16.7823 9.92671 16.7786 9.82834C16.919 9.71502 17.7872 9.00119 18 8.54228C18 8.54228 17.295 8.84285 16.6049 8.91366C16.6036 8.91366 16.6019 8.91399 16.6005 8.91399C16.6005 8.91399 16.6019 8.91329 16.6042 8.91157C16.6678 8.86799 17.5567 8.24726 17.6771 7.50767C17.6771 7.50767 17.1784 7.78072 16.4802 8.01959C16.3646 8.05898 16.2436 8.09771 16.1188 8.13361C15.6687 7.64087 15.029 7.33331 14.3189 7.33331C12.9568 7.33331 11.853 8.46523 11.853 9.86145C11.853 10.0585 11.8751 10.2502 11.9169 10.4344C11.7266 10.4264 8.82793 10.2597 6.85598 7.80996C6.85598 7.80996 5.67744 9.46042 7.5583 11.1576C7.5583 11.1576 6.98655 11.1342 6.49327 10.8319C6.49327 10.8319 6.3121 12.8314 8.44212 13.3426C8.44212 13.3426 8.02299 13.5054 7.35434 13.3893C7.35434 13.3893 7.72827 15.0049 9.62069 15.1559C9.62069 15.1559 8.12425 16.5426 6 16.2173L6.00068 16.2175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.c67559009ea20f8db64b0da30a87459e.svg";
export { ForwardRef as ReactComponent };